import { React, useState } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import Checkbox, { CheckboxGroup } from '@iso/components/uielements/checkbox';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
import Button from '@iso/components/uielements/button';
import {
    InputSearch,
    InputGroup,
    Textarea,
} from '@iso/components/uielements/input';
import { useContext } from 'react';
import { Spin, Tooltip, message, Input, Form } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
// import closeIcon from '@iso/assets/images/icon/close-icon.svg';
import CloseIcon from '@iso/assets/images/icon/07-icon.svg';
import styled, { createGlobalStyle } from 'styled-components';
import { SelectOption } from '@iso/components/uielements/select';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import initialData from '../../../redux/scrumBoard/data';
import { AppContext } from '../../../context/ContextProvider';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
// import { borderRadius } from '../../../library/helpers/style_utils';
import Select from '@iso/containers/Projects/AddEnvironmentVariable.style';
// import Dropzone from '@iso/components/uielements/dropzone';
// import DropzoneWrapper from '../AdvancedUI/Dropzone/Dropzone.styles';
// import Alert from '@iso/components/Feedback/Alert';
import Scrollbars from 'react-custom-scrollbars-2';
import { AlertContext } from '../../../context/alertContext';
import api from '../../../api';
import { convertTextType, customFilterOption, customSortOptions, formatErrors, hasPermission, isValidCommon } from '../../../context/helper';
import UploadFiles from '@iso/components/utility/UploadFiles';
import { InfoCircleFilled } from '@ant-design/icons';
// import InputBox from '@iso/containers/Ecommerce/Checkout/InputBox.js';
import { CustomModal } from '../../Dashboard/CustomComponents/PageLoader.style';


var ReactDOMServer = require('react-dom/server');

const Option = SelectOption;

const marginsBot = {
    position: 'fixed',
    opacity: '100%',
    transition: 'all 1s ease',
    top: "7vw",
    right: "0",
    zIndex: '1000',
    width: "25%",
    padding: '15px'
};

const fadeMarginBot = {
    position: 'fixed',
    opacity: '0',
    transition: 'all 1s ease',
    top: "7vw",
    right: "0",
    zIndex: '-1',
    width: "25%",
    padding: '15px'
};

let titleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontSize: "16px",
    fontWeight: "500"
}

let subTitleStyle = {
    fontSize: "14px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontType: "regular",
    fontWeight: "400"
}

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }

  .isoHelperText {
    color: red;
    font-weight: 400;
    font-size: 12px;
    margin-top: 30%;
    display: flex;
    justify-content: center;
  }

  .header__center {
    font-size: 15px;
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
    grid-column-gap: 1.2rem;
    align-items: center;
    color: #7C7C7C;
    margin: 50px;
    margin-inline: 49px;
  }

  .header__center::before, .header__center::after {
    content: "";
    display: block;
    height: 1px;
    background-color: #F4F4F4;
  }
`;

const addButtonStyle = {
    marginRight: "10px",
    fontSize: "25px"
};

const buttonCss = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px 46px"
};

const footerStyle = {
    width: "100%",
    position: "absolute",
    bottom: "0",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "20px 10px",
    borderTop: "1px solid #B1B1B1",
    background: "#FFF",
}

export default ({
    // handleSubmit,
    data,
    valueFromDropdown,
    update,
    service,
    type,
    selectedAppId,
    values,
    submitCount,
    onCancel,
    onDelete,
    openDrawer,
    onEditCancel,
    tabSelected,
    currentProject,
    setCurrentProject,
    setHasChanges,
    fromEnvironment,
    fromWorkflow,
    setEnvVarsList,
}) => {

    const { openRightDrawer, setOpenRightDrawer, infraModuleData, setInfraModuleData } = useContext(AppContext);
    const { alertOptions, set_alertOptions } = useContext(AlertContext);

    const [form] = Form.useForm();

    // The request still sends the slug as `repo` — the backend needs it for the provider
    // API path and uses repo_url only to detect the host (infra_workflow/utils.py
    // public_repo_file_api_url). This only changes what the read-only field shows.
    const isPublicImportSource = infraModuleData?.workflowBuilder?.sourceConfig?.config?.source === "public";

    const [importData, setImportData] = useState({
        account_id: infraModuleData?.workflowBuilder?.sourceConfig?.config?.accountId ? infraModuleData.workflowBuilder.sourceConfig.config.accountId : "",
        repo: infraModuleData?.workflowBuilder?.sourceConfig?.config?.repo ? infraModuleData.workflowBuilder.sourceConfig.config.repo : "",
        branch: infraModuleData?.workflowBuilder?.sourceConfig?.config?.branch ? infraModuleData.workflowBuilder.sourceConfig.config.branch : "",
        app_source_type: infraModuleData?.workflowBuilder?.sourceConfig?.config?.sourceType === "Git Repositories" ? 1 : "",
        isPrivate: infraModuleData?.workflowBuilder?.sourceConfig?.config?.isPrivate ? true : false,
        repo_url: infraModuleData?.workflowBuilder?.sourceConfig?.config?.repoUrl ? infraModuleData.workflowBuilder.sourceConfig.config.repoUrl : "",
        repo_id: infraModuleData?.workflowBuilder?.sourceConfig?.config?.repoId ? infraModuleData.workflowBuilder.sourceConfig.config.repoId : "",
        execution_path: infraModuleData?.config?.executorPath ? infraModuleData.config.executorPath : "./",
        git_integration_type: infraModuleData?.workflowBuilder?.sourceConfig?.config?.source || "",
        importOption: type === "terraform" ? "" : "Upload .env file",
        file: "",
        secretFile: "",
        uploadContent: false,
    });

    const [fetching, setFetching] = useState(false);
    const [repoList, setRepoList] = useState([]);
    const [myDropdown, setMyDropdown] = useState([]);
    const [file, setFile] = useState(null);
    const [jsonData, setJsonData] = useState();
    const [filesList, setFilesList] = useState([]);
    const [branchLoad, setBranchLoad] = useState(true);
    const [importOptions, setImportOptions] = useState([]);
    const [secretList, setSecretList] = useState([]);
    const [error, setError] = useState({
        status: false,
        msg: "Success"
    });

    const navigate = useNavigate();
    const location = useLocation();
    const [searchValue, setSearchValue] = useState("");
    const [secretLoad, setSecretLoad] = useState(false);
    const [loadingSecrets, setLoadingSecrets] = useState(false); //adds loader when importing variables for secret maanger or repo

    useEffect(() => {
        form.setFieldsValue({ ...importData });
    }, [importData]);

    const callGitlabPublicBranchesApi = (url) => {
        fetch(url)
            .then(async (res) => await res.json())
            .then((data) => {
                console.log('branches data :', data);
                if (data.type !== "error") {
                    if (data.message) {
                        console.log("Unable to connect to gitlab. Please check if repo is public");
                        setError({
                            status: true,
                            type: "branch",
                            msg: "Unable to connect to gitlab. Please check if repo is public"
                        });
                        // toggleAlert("error", "Error", "Unable to connect to github. Please check if repo is public");
                    }
                    else {
                        let branches = [];
                        data.map((temp, ind) => {
                            branches.push(
                                <Option key={ind} name="branch" value={temp.name}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                        <span>{temp.name}</span>
                                    </div>
                                </Option>
                            );
                        });
                        setRepoList(branches);
                    }
                }
                else {
                    toggleAlert("Error", "Error", data.error?.message);
                }
                setBranchLoad(false);
            })
            .catch((error) => {
                console.error('Error fetching branches:', error);
                setBranchLoad(false);
            });
    }

    useEffect(() => {
        console.log("Executing this useEffect");
        let options = type === "terraform" ? ["Repo", "Upload .tf/.tfvars file"] : ["Upload .env file"];
        options.forEach((val) => {
            importOptions.push(<Option key={val} name="importOption" value={val}>
                {val}
            </Option>);
        });
        setImportOptions([...importOptions]);
    }, []);

    // useEffect(() => {
    //     console.log("Import data.importOption: ", importData.importOption);
    //     if (importData.importOption === "Secrets") {
    //         setSecretLoad(true);
    //         api.get(process.env.REACT_APP_API_URI + `/api/integration/secret-manager/list/secrets/${currentProject.accountDetails?.region}/${currentProject.accountDetails?.account_id}`)
    //             .then((res) => {
    //                 let data = res.data;
    //                 if (data.status) {
    //                     let secrets = [];
    //                     data.data.forEach((val) => {
    //                         secrets.push(<Option name="secretFile" key={val} value={val}>
    //                             {val}
    //                         </Option>);
    //                     });
    //                     setSecretList([...secrets]);
    //                     //setSecretList(data.data);
    //                 }
    //                 else {
    //                     console.log("Error");
    //                     setError({
    //                         msg: data.error_details.error,
    //                         status: true
    //                     });
    //                 }
    //                 setSecretLoad(false);
    //             }).catch((err) => {
    //                 console.log("Error");
    //                 setSecretLoad(false);
    //             });
    //     }
    // }, [importData.importOption]);

    useEffect(() => {
        console.log("data in importEnvironmentVariables :", data);
        console.log("service in importEnvironmentVariables :", service);
        console.log("currentProject in importEnvironmentVariables :", currentProject);
        console.log("My import data: ", importData.importOption === "Repo");

        if (importData.importOption === "Repo") {
            if (!importData.isPrivate && importData.app_source_type === 1) {
                let rawData = importData?.repo_url?.split("/");
                console.log("rawData :", rawData);

                if (importData && !importData.isPrivate) {
                    let rawData = importData.repo_url.split("/");
                    console.log("rawData :", rawData);
                    let owner = rawData[3];
                    let repoName = rawData[4];

                    if (repoName) {
                        repoName = repoName.split(".git")[0];
                    }

                    if (importData?.repo_url?.includes("https://github.com")) {
                        fetch(`https://api.github.com/repos/${owner}/${repoName}/branches`)
                            .then(async (res) => await res.json())
                            .then((data) => {
                                console.log('branches data :', data);
                                if (data.type !== "error") {
                                    if (data.message) {
                                        console.log("Unable to connect to github. Please check if repo is public.");
                                        setError({
                                            status: true,
                                            type: "branch",
                                            msg: "Unable to connect to github. Please check if repo is public."
                                        });
                                        // toggleAlert("error", "Error", "Unable to connect to github. Please check if repo is public");
                                    }
                                    else {
                                        let branches = [];
                                        data.map((temp, ind) => {
                                            branches.push(
                                                <Option key={ind} name="branch" value={temp.name}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                        <span>{temp.name}</span>
                                                    </div>
                                                </Option>
                                            );
                                        });
                                        setRepoList(branches);
                                    }
                                }
                                else {
                                    toggleAlert("Error", "Error", data.error?.message);
                                }
                                setBranchLoad(false);
                            })
                            .catch((error) => {
                                console.error('Error fetching branches:', error);
                                setBranchLoad(false);
                            });
                    }
                    else if (importData && importData.repo_id) {
                        // GitLab instance details
                        let gitlabInstance = `https://${rawData[2]}`;
                        let projectPath = `${owner}%2F${repoName}`;

                        let url = `${gitlabInstance}/api/v4/projects/${projectPath}/repository/branches`;
                        callGitlabPublicBranchesApi(url);
                    }
                    else if (importData?.repo_url?.includes("bitbucket")) {
                        fetch(`https://api.bitbucket.org/2.0/repositories/${owner}/${repoName}/refs/branches?sort=-target.date`)
                            .then(async (res) => await res.json())
                            .then((data) => {
                                console.log('branches data :', data);
                                if (data.type !== "error") {
                                    if (data.message) {
                                        console.log("Unable to connect to bitbucket. Please check if repo is public.");
                                        setError({
                                            status: true,
                                            type: "branch",
                                            msg: "Unable to connect to bitbucket. Please check if repo is public."
                                        });
                                    }
                                    else {
                                        let branches = [];
                                        data.map((temp, ind) => {
                                            branches.push(
                                                <Option key={ind} name="branch" value={temp.name}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                        <span>{temp.name}</span>
                                                    </div>
                                                </Option>
                                            );
                                        });
                                        setRepoList(branches);
                                    }
                                }
                                else {
                                    toggleAlert("Error", "Error", data.error?.message);
                                }
                                setBranchLoad(false);
                            })
                            .catch((error) => {
                                console.error('Error fetching branches:', error);
                                setBranchLoad(false);
                                // toggleAlert("error", "Error", "Something went wrong. Please try again.");
                            });
                    }
                    else {
                        // GitLab instance details
                        let gitlabInstance = `https://${rawData[2]}`;
                        let projectPath = `${owner}%2F${repoName}`;

                        let url = `${gitlabInstance}/api/v4/projects/${projectPath}/repository/branches`;
                        callGitlabPublicBranchesApi(url);
                    }
                }
            }
            else if (importData.app_source_type === 1) {
                api.post(process.env.REACT_APP_API_URI + '/api/integration/vcs/branch/', {
                    account_id: importData.account_id,
                    repo_name: importData.repo
                }).then((res) => {
                    let data = res.data;
                    if (!data.status) {
                        let err = formatErrors(data.error_details);
                        console.log("Error :", err);
                        // toggleAlert("error", "Error", err);
                    }
                    else {
                        let branches = [];
                        data.data.map((temp, ind) => {
                            branches.push(
                                <Option key={ind} name="branch" value={temp}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                        <span>{temp}</span>
                                    </div>
                                </Option>
                            );
                        });
                        setRepoList(branches);
                    }
                    setBranchLoad(false);
                })
                    .catch((err) => {
                        console.log("Error :", err);
                        setBranchLoad(false);
                        // toggleAlert("error", "Error", "Something went wrong. Please try again.");
                    });
            }
        }

        // get .env Files from github
        // getFilesFromRepo();
    }, [importData.importOption]);


    useEffect(() => {
        if (importData.importOption === "Repo" && type !== "terraform") {
            setFetching(true);
            getFilesFromRepo();
        }
    }, [importData.branch])


    const handelClick = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
                columnId: ""
            },
        });
    }

    const getTerraformFilesFromRepo = (allEnvNames) => {
        const isPublicRepo = importData.git_integration_type === "public" || !importData.account_id;
        const myRepo = importData.repo;

        let payload = {
            "git_account_id": importData.account_id,
            "git_integration_type": isPublicRepo ? "public" : (importData.git_integration_type || "private"),
            "repo_url": importData.repo_url || "",
            "repo": myRepo,
            "branch": importData.branch,
            "execution_path": importData.execution_path,
            "file_name": importData.file
        }

        api.post(process.env.REACT_APP_API_URI + `/api/infra-workflow/variables/`, payload)
            .then((res) => {
                let tempData = res.data;
                console.log("data in infra-workflow/variables/ api :", tempData);

                if (!tempData.status) {
                    let err = formatErrors(tempData.error_details);
                    toggleAlert("error", "Error", err);
                }
                else {
                    if (tempData.data) {
                        let tempEnvs = [];

                        tempData.data.map((temp, idx) => {
                            let key = temp.name.trim();
                            let value = ["map(any)", "map(string)", "any", "list(string)", "bool"].includes(temp.type) ? JSON.stringify(temp.default, "", 2) : temp.default;
                            let valueType = temp.type;

                            console.log("value :", value);
                            console.log("valueType and convertedType :", valueType, convertTextType[valueType]);
                            console.log("isValidCommon(value, convertTextType[type]) :", isValidCommon(value, convertTextType[valueType]));

                            // Auto-flag sensitively-named variables as secrets (user can untoggle).
                            let looksSecret = /(secret|token|password|passwd|api_?key|access_?key|private_?key|credential)/i.test(key);
                            tempEnvs.push({
                                id: idx + (data?.length > 0 ? data.length : 0),
                                key: idx + (data?.length > 0 ? data.length : 0),
                                varName: key,
                                originalKey: key,
                                valueFrom: "Value",
                                value: value,
                                isSecret: looksSecret,
                                dependOn: null,
                                error: (!value || allEnvNames.includes(key) || !isValidCommon(value, convertTextType[valueType])) ? true : false,
                                isHide: looksSecret,
                                keys: key,
                                syncProj: false,
                                injectAt: "",
                                type: valueType,
                                // injectAt: fromWorkflow ? ["Build Time"] : ["Run Time"]
                                // isSecretManager
                            });
                            allEnvNames.push(key);
                        });

                        setEnvVarsList([
                            ...data,
                            ...tempEnvs
                        ]);

                        setHasChanges(true);
                        handelClick();
                    }
                    else {
                        toggleAlert("error", "Error", "Terraform env var file not found. Please try changing branch or file name.");
                    }
                }
                setLoadingSecrets(false);
            })
            .catch((err) => {
                setFetching(false);
                console.log("Error :", err);
                toggleAlert("error", "Error", "Something went wrong. Please try again.");
                setLoadingSecrets(false);
            });
    }

    const getFilesFromRepo = () => {
        api.get(process.env.REACT_APP_API_URI + `/api/project_env/get_env_file/${service.serviceId}?branch=${importData.branch}`)
            .then((res) => {
                let data = res.data;
                if (!data.status) {
                    let err = formatErrors(data.error_details);
                    console.log("Error :", err);
                    setFetching(false);
                }
                else if (!data.data) {
                    setFetching(false);
                    console.log("File not found in given repo. Please try changing you branch.");
                    // toggleAlert("error", "Error", "File not found in given repo. Please try changing you branch.");
                }
                else if (data.data) {
                    let envFile = [];
                    data.data.map((temp, ind) => {
                        envFile.push(
                            <Option key={ind} name="file" value={temp.file_path}>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "Center" }}>
                                    <span>{temp.file_name}</span>
                                </div>
                            </Option>
                        );
                    });

                    setFilesList(envFile);
                    setFetching(false);
                }
            })
            .catch((err) => {
                setFetching(false);
                console.log("Error :", err);
                // toggleAlert("error", "Error", "Something went wrong. Please try again.");
            });
    }

    const handleReadFile = (file) => {
        const reader = new FileReader();
        console.log("Files :", file);
        setError({ ...error, status: false });

        reader.onload = (e) => {
            try {
                // console.log("e.target :", e.target);
                // console.log("e.target.result :", e.target.result);
                setJsonData(e.target.result);
                setImportData({ ...importData, uploadContent: true });
                message.success(`${file.name} uploaded successfully. Please proceed.`);
            } catch (error) {
                console.error(`Error parsing ${type === "terraform" ? `.tf/.tfvars` : `.env`} file:`, error);
            }
        };

        if (file) {
            setFile({
                ...file,
                uid: file.uid,
                name: file.name,
                status: 'done',
            });
            reader.readAsText(file);
        }
    };

    const handelRemoveFile = () => {
        console.log("handelRemoveFile :", file);
        eventHandlers.removedfile();
    }

    const componentConfig = {
        iconFiletypes: type === "terraform" ? ['.tf', '.tfvars'] : ['.env', '.env.sample'],   // ['.tf', '.jpg', '.png', '.gif']
        method: true,
        showFiletypeIcon: false,
        uploadMultiple: false,
        maxFiles: 1,
        maxFilesize: 2, // MB
        dictMaxFilesExceeded: 'You can only upload upto 1 image',
        dictRemoveFile: 'Delete',
        dictCancelUploadConfirmation: 'Are you sure to cancel upload?',
        postUrl: 'no-url',
    };

    const djsConfig = {
        acceptedFiles: type === "terraform" ? ['.tf', '.tfvars'] : ['.env', '.env.sample'],
        autoProcessQueue: false,
        maxFiles: 1,
        uploadMultiple: true,
        // previewTemplate: (
        //     <div>
        //         <p>Selected File</p>
        //         {/* <button onClick={() => setFile(null)}>Remove File</button> */}
        //         </div>
        //   )
        // previewTemplate: ReactDOMServer.renderToStaticMarkup(
        //     <div className="dz-preview dz-file-preview">
        //       <div className="dz-details">
        //         <div className="dz-filename"><span data-dz-name="true"></span></div>
        //         <img data-dz-thumbnail="true" />
        //       </div>
        //       <div className="dz-progress"><span className="dz-upload" data-dz-uploadprogress="true"></span></div>
        //       <div className="dz-success-mark"><span>✔</span></div>
        //       <div className="dz-error-mark"><span>✘</span></div>
        //       <div className="dz-error-message"><span data-dz-errormessage="true"></span></div>
        //     </div>
        // )
    };

    const eventHandlers = {
        addedfile: (newFile) => {
            setFile(newFile);
            console.log("file in addedfile :", newFile);
            handleReadFile(newFile);
        },
        success: (newFile) => {
            console.log("newFile in success :", newFile);
            toggleAlert("success", "Success", `${newFile.name} successfully uploaded`);
        },
        error: (error) => {
            console.log("error :", error);
            toggleAlert("error", "Error", "Error in uploading File");
        },
        removedfile: (newFile) => {
            console.log("newFile in removedfile :", newFile);
            setFile(null);
        }
    };

    const handleSelectChange = (value, event) => {
        console.log("inside handleSelectChange");
        setImportData({ ...importData, [event.name]: value });
        setError({ ...error, status: false });
    }

    // Terraform writes collections in HCL — `{ Environment = "dev" }`, unquoted keys,
    // trailing commas, newline separators — but the variable table validates every value
    // with JSON.parse (helper.checkJsonString). A raw HCL literal therefore fails
    // validation, the row is flagged, and Save silently refuses. Convert to real JS values
    // so the value can be re-emitted as JSON. Throws for anything exotic (interpolations,
    // function calls, variable references), which the caller keeps as literal text.
    function hclLiteralToJson(raw) {
        const s = String(raw);
        let i = 0;

        const skip = () => {
            while (i < s.length) {
                if (/[\s,]/.test(s[i])) { i++; continue; }
                if (s[i] === "#" || (s[i] === "/" && s[i + 1] === "/")) {
                    while (i < s.length && s[i] !== "\n") i++;
                    continue;
                }
                break;
            }
        };

        const parseString = () => {
            i++; // opening quote
            let out = "";
            while (i < s.length && s[i] !== '"') {
                if (s[i] === "\\") {
                    const next = s[i + 1];
                    out += next === "n" ? "\n" : next === "t" ? "\t" : next;
                    i += 2;
                    continue;
                }
                out += s[i++];
            }
            if (s[i] !== '"') throw new Error("unterminated string");
            i++;
            return out;
        };

        const parseIdent = () => {
            const start = i;
            while (i < s.length && /[A-Za-z0-9_.-]/.test(s[i])) i++;
            if (i === start) throw new Error("expected identifier");
            return s.slice(start, i);
        };

        const parseValue = () => {
            skip();
            const ch = s[i];

            if (ch === '"') return parseString();

            if (ch === "[") {
                i++;
                const arr = [];
                skip();
                while (i < s.length && s[i] !== "]") {
                    arr.push(parseValue());
                    skip();
                }
                if (s[i] !== "]") throw new Error("unterminated list");
                i++;
                return arr;
            }

            if (ch === "{") {
                i++;
                const obj = {};
                skip();
                while (i < s.length && s[i] !== "}") {
                    const key = s[i] === '"' ? parseString() : parseIdent();
                    skip();
                    // HCL accepts both `k = v` and `k: v` inside an object.
                    if (s[i] !== "=" && s[i] !== ":") throw new Error("expected = in object");
                    i++;
                    obj[key] = parseValue();
                    skip();
                }
                if (s[i] !== "}") throw new Error("unterminated object");
                i++;
                return obj;
            }

            const start = i;
            while (i < s.length && !/[\s,\]}]/.test(s[i])) i++;
            const token = s.slice(start, i);
            if (!token) throw new Error("empty value");
            if (/^-?\d+(\.\d+)?$/.test(token)) return Number(token);
            if (/^true$/i.test(token)) return true;
            if (/^false$/i.test(token)) return false;
            if (token === "null") return null;
            throw new Error("unsupported token: " + token);
        };

        const value = parseValue();
        skip();
        if (i !== s.length) throw new Error("trailing content");
        return value;
    }

    // Mirrors helper.checkJsonString so the type we report is one the validator will agree
    // with. Anything it cannot classify gets an unmapped type, which skips validation
    // rather than flagging a value that is actually fine.
    function tfvarsTypeOf(value) {
        if (typeof value === "boolean") return "bool";
        if (typeof value === "number") return "number";
        if (typeof value === "string") return "string";

        if (Array.isArray(value)) {
            if (value.length === 0) return "list(string)";
            return value.every((v) => typeof v === "string") ? "list(string)" : "";
        }

        if (value !== null && typeof value === "object") {
            const vals = Object.values(value);
            if (vals.length === 0) return "map(string)";
            const kinds = new Set(vals.map((v) => (Array.isArray(v) ? "array" : typeof v)));
            if (kinds.size === 1) {
                return kinds.has("string") ? "map(string)" : "map(any)";
            }
            return "";
        }

        return "";
    }

    // A .tfvars file assigns values (name = "x"); a .tf file declares them
    // (variable "name" { default = "x" }). Only the Repo option reads declarations — it
    // parses variables.tf server-side — so the upload path must read assignments instead.
    // Returns the same {name, type, default} shape the importer already consumes.
    function parseTfvarsList(tfvarsContent) {
        const results = [];
        const lines = String(tfvarsContent).replace(/\r\n?/g, "\n").split("\n");

        // Collections span lines, so accumulate until the brackets balance.
        const depthOf = (text) => {
            let depth = 0, inString = false, escaped = false;
            for (const ch of text) {
                if (escaped) { escaped = false; continue; }
                if (ch === "\\") { escaped = true; continue; }
                if (ch === '"') { inString = !inString; continue; }
                if (inString) continue;
                if (ch === "[" || ch === "{" || ch === "(") depth++;
                if (ch === "]" || ch === "}" || ch === ")") depth--;
            }
            return depth;
        };

        let pending = null;
        let depth = 0;
        let skipDepth = 0;

        for (const line of lines) {
            // Inside a block body (a .tf file renamed to .tfvars, say): skip it wholesale,
            // otherwise its attributes get imported as variables named "default"/"type".
            if (skipDepth > 0) {
                skipDepth += depthOf(line);
                continue;
            }

            if (pending !== null) {
                pending.raw += " " + line.trim();
                depth += depthOf(line);
                if (depth <= 0) {
                    results.push(finaliseTfvar(pending.name, pending.raw));
                    pending = null;
                    depth = 0;
                }
                continue;
            }

            const stripped = line.trim();
            if (!stripped || stripped.startsWith("#") || stripped.startsWith("//")) continue;

            const eq = stripped.indexOf("=");
            const brace = stripped.indexOf("{");

            // A block header opens a brace with no assignment before it (`variable "x" {`),
            // unlike a map value (`tags = {`) where the '=' comes first.
            if (brace > -1 && (eq === -1 || brace < eq)) {
                skipDepth = depthOf(stripped);
                continue;
            }

            if (eq < 1) continue;

            const name = stripped.slice(0, eq).trim();
            // Assignments only: a bare identifier on the left, never a block header.
            if (!/^[A-Za-z_][A-Za-z0-9_-]*$/.test(name)) continue;

            const raw = stripped.slice(eq + 1).trim();
            depth = depthOf(raw);
            if (depth > 0) {
                pending = { name, raw };
                continue;
            }
            results.push(finaliseTfvar(name, raw));
        }

        // An unterminated collection is still worth importing rather than dropping silently.
        if (pending !== null) results.push(finaliseTfvar(pending.name, pending.raw));

        return results;
    }

    function finaliseTfvar(name, raw) {
        // Trailing inline comment, but not a '#' inside a quoted value.
        let text = raw;
        if (!/^".*"$/s.test(text)) {
            text = text.replace(/\s+(#|\/\/).*$/, "").trim();
        }

        try {
            const parsed = hclLiteralToJson(text);
            // Scalars go in bare; collections must be JSON for the table's validator.
            const value = (parsed !== null && typeof parsed === "object")
                ? JSON.stringify(parsed)
                : String(parsed);
            return { name, type: tfvarsTypeOf(parsed), default: value };
        } catch (err) {
            // Interpolations, heredocs, function calls: keep the author's text verbatim and
            // leave the type unset so validation does not reject something we simply
            // could not classify.
            console.warn(`Could not parse .tfvars value for "${name}":`, err?.message);
            const unquoted = /^".*"$/s.test(text) ? text.slice(1, -1).replace(/\\"/g, '"') : text;
            return { name, type: "", default: unquoted };
        }
    }

    function readHclLiteral(body, start) {
        let i = start;
        let depth = 0;
        let inString = false;
        let escaped = false;

        while (i < body.length) {
            const ch = body[i];

            if (inString) {
                if (escaped) escaped = false;
                else if (ch.charCodeAt(0) === 92) escaped = true;
                else if (ch === '"') inString = false;
                i++;
                continue;
            }

            if (ch === '"') { inString = true; i++; continue; }
            if (ch === "[" || ch === "{" || ch === "(") { depth++; i++; continue; }
            if (ch === "]" || ch === "}" || ch === ")") {
                if (depth === 0) break;
                depth--;
                i++;
                continue;
            }
            if (ch.charCodeAt(0) === 10 && depth <= 0) break;
            i++;
        }

        return body.slice(start, i).trim();
    }

    function findBlockEnd(text, start) {
        let i = start;
        let depth = 1;
        let inString = false;
        let escaped = false;

        while (i < text.length) {
            const ch = text[i];

            if (inString) {
                if (escaped) escaped = false;
                else if (ch.charCodeAt(0) === 92) escaped = true;
                else if (ch === '"') inString = false;
                i++;
                continue;
            }

            if (ch === '"') { inString = true; i++; continue; }
            if (ch === "{" || ch === "[" || ch === "(") { depth++; i++; continue; }
            if (ch === "}" || ch === "]" || ch === ")") {
                depth--;
                if (depth === 0) return i;
                i++;
                continue;
            }
            i++;
        }

        return text.length;
    }

    function parseTfDeclarationsList(tfContent) {
        const results = [];
        const varHeaderRE = /variable\s+"([^"]+)"\s*{/g;
        const typeAtRE = /^\s*type\s*=\s*/m;
        const defaultAtRE = /^\s*default\s*=\s*/m;

        let match;
        while ((match = varHeaderRE.exec(tfContent)) !== null) {
            const name = match[1];
            const bodyStart = match.index + match[0].length;
            const bodyEnd = findBlockEnd(tfContent, bodyStart);
            const varBody = tfContent.slice(bodyStart, bodyEnd);
            // Resume after this block so a nested "}" cannot be mistaken for the next one.
            varHeaderRE.lastIndex = bodyEnd;

            const typeAt = typeAtRE.exec(varBody);
            const declaredType = typeAt ? readHclLiteral(varBody, typeAt.index + typeAt[0].length) : "";

            const defaultAt = defaultAtRE.exec(varBody);
            if (!defaultAt) {
                results.push({ name, type: declaredType, default: "" });
                continue;
            }
            const rawDefault = readHclLiteral(varBody, defaultAt.index + defaultAt[0].length);
            const finalised = finaliseTfvar(name, rawDefault);
            results.push({ name, type: declaredType || finalised.type, default: finalised.default });
        }

        return results;
    }

    const handelCreate = async (e, addAnother) => {
        console.log("inside handelCreate importData:", importData);
        // console.log("inside handelCreate currentProject:", currentProject);

        // Already exist env varName to check for duplication in future
        let allEnvNames = [];
        infraModuleData.terraformEnvVars && infraModuleData.terraformEnvVars.map((temp, idx) => {
            allEnvNames.push(temp.varName);
        });

        console.log("allEnvNames :", allEnvNames);
        if (["Upload .tf/.tfvars file", "Upload .env file"].includes(importData.importOption)) {
            if (importData.uploadContent) {
                console.log("jsonData :", jsonData);
                let rawData = "";

                if (jsonData) {
                    if(type === "terraform"){
                        const uploadedName = String(file?.name || "").toLowerCase();
                        rawData = uploadedName.endsWith(".tf")
                            ? parseTfDeclarationsList(jsonData)
                            : parseTfvarsList(jsonData);
                    }
                    else{
                        rawData = jsonData.split("\r\n");
                        if (rawData[0].includes("\n")) {
                            console.log("Includes \n insted or \r\n ");
                            rawData = jsonData.split("\n");
                        }
                    }

                    console.log("rawData :", rawData);

                    let tempEnvs = [];
                    if (rawData.length > 0) {
                        rawData.map((temp, idx) => {
                            if (type === "terraform" || (!temp.trim().startsWith("#") && !temp.trim().startsWith("//") && temp.includes("="))) {
                                let firstEqualsIndex = type === "terraform" ? -1 : temp.indexOf("=");

                                let key = type === "terraform" ? temp.name.trim() : temp.substring(0, firstEqualsIndex).trim();
                                let value = type === "terraform" ? temp.default : temp.substring(firstEqualsIndex + 1);
                                let valueType = type === "terraform" ? temp.type : "";

                                tempEnvs.push({
                                    id: idx + (data?.length > 0 ? data.length : 0),
                                    key: idx + (data?.length > 0 ? data.length : 0),
                                    varName: key,
                                    originalKey: key,
                                    valueFrom: "Value",
                                    value: value,
                                    isSecret: false,
                                    dependOn: null,
                                    error: !value || allEnvNames.includes(key) ? true : false || key.startsWith(" ") || key.endsWith(" ") || !isValidCommon(value, convertTextType[valueType]),
                                    isHide: false,
                                    keys: key,
                                    syncProj: false,
                                    injectAt: "",
                                    type: valueType,
                                });

                                allEnvNames.push(key);
                            }
                        });

                        console.log("tempEnvs :", tempEnvs);

                        setEnvVarsList([
                            ...data,
                            ...tempEnvs
                        ]);

                        setHasChanges(true);
                        handelClick();
                    }
                }
                else {
                    setError({
                        status: true,
                        msg: "No variables found."
                    });
                }
            }
        }
        else if (importData.importOption === "Repo") {
            try {
                const values = await form.validateFields();
                console.log('Success:', values);
                setError({ ...error, status: false });
                setLoadingSecrets(true);

                getTerraformFilesFromRepo(allEnvNames);
            }
            catch (err) {
                console.log("Found error :", err);
            }

            // if (!importData.repo) {
            //     setError({
            //         status: true,
            //         msg: "Repo name not found. Please try again"
            //     });
            // }
            // else if (!importData.repo || !importData.branch || !importData.execution_path || !importData.file) {
            //     setError({
            //         status: true,
            //         msg: "Please Fill all fields marked with *"
            //     });
            // }
            // else {
            //     setError({ ...error, status: false });
            //     console.log("current data in add...", data);
            //     setLoadingSecrets(true);
            //     getTerraformFilesFromRepo(allEnvNames);
            // }
        }
        // else if (importData.importOption === "Secrets") {     // for project only
        //     if (importData.secretFile === "") {
        //         setError({
        //             status: true,
        //             msg: "Please Fill all fields marked with *"
        //         });
        //     }
        //     else {
        //         setLoadingSecrets(true);
        //         api.get(process.env.REACT_APP_API_URI + `/api/project_env/secrets?region=${currentProject.accountDetails?.region}&account_id=${currentProject?.accountDetails?.account_id}&secret_name=${importData.secretFile}`)
        //             .then((res) => {
        //                 let data = res.data;
        //                 console.log("data in get_env_file api :", data);
        //                 if (!data.status) {
        //                     let err = formatErrors(data.error_details);
        //                     setError({
        //                         msg: err,
        //                         status: true
        //                     });
        //                     //toggleAlert("error", "Error", err);
        //                 }
        //                 else {
        //                     if (data.data && Object.keys(data.data).length > 0) {
        //                         let tempEnvs = [];

        //                         let convertEnvs = [];

        //                         Object.keys(data.data).forEach((val) => {
        //                             convertEnvs.push({
        //                                 [val]: data.data[val].toString()
        //                             });
        //                         });

        //                         convertEnvs.map((temp, idx) => {
        //                             let key = Object.keys(temp)[0];
        //                             let value = Object.values(temp)[0];

        //                             // if (allEnvNames.includes(key)) {
        //                             //     service.envs.map((obj, idx) => {
        //                             //         if (obj.varName === key) {
        //                             //             service.envs[idx].value = value;
        //                             //             service.envs[idx].valueFrom = "Value";
        //                             //             service.envs[idx].isSecret = true;
        //                             //             service.envs[idx]["dependOn"] = null;
        //                             //             service.envs[idx]["importFrom"] = "Secret Manager";
        //                             //         }
        //                             //     });
        //                             // }
        //                             // else {
        //                             tempEnvs.push({
        //                                 varName: key,
        //                                 originalKey: key,
        //                                 valueFrom: "Value",
        //                                 value: value,
        //                                 isSecret: true,
        //                                 isHide: true,
        //                                 dependOn: null,
        //                                 importFrom: "Secret Manager",
        //                                 error: !value || allEnvNames.includes(key) ? true : false,
        //                                 injectAt: ["Run Time"],
        //                                 id: idx,
        //                                 key: idx,
        //                                 keys: key,
        //                                 syncProj: false,
        //                             });
        //                             allEnvNames.push(key);
        //                             // }
        //                         });

        //                         console.log("tempEnvs :", tempEnvs);

        //                         currentProject.importDetails = {
        //                             ...importData
        //                         };

        //                         currentProject.accountDetails = {
        //                             ...currentProject.accountDetails,
        //                             // secret_name: importData.secretFile
        //                         };

        //                         currentProject?.tasks?.map((temp, idx) => {
        //                             if (temp.id === service.id) {
        //                                 // currentProject.tasks[idx].importDetails = {
        //                                 //     ...importData
        //                                 // };
        //                                 // currentProject.tasks[idx].accountDetails = {
        //                                 //     ...currentProject.tasks[idx].accountDetails,
        //                                 //     secret_name: importData.secretFile
        //                                 // };
        //                                 currentProject.tasks[idx].secret_name = importData.secretFile;
        //                                 service.envs.unshift(...tempEnvs);
        //                                 currentProject.tasks[idx].envs = service.envs;
        //                                 currentProject.tasks[idx].importDetails = {
        //                                     ...importData
        //                                 };
        //                             }
        //                         });

        //                         setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
        //                         localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
        //                         setHasChanges(true);
        //                         handelClick();
        //                     }
        //                     else {
        //                         //toggleAlert("error", "Error", "No secrets found.");
        //                         setError({
        //                             status: true,
        //                             msg: "No secrets found."
        //                         });
        //                     }
        //                 }
        //                 setLoadingSecrets(false);
        //             })
        //             .catch((err) => {
        //                 console.log("Error :", err);
        //                 toggleAlert("error", "Error", "Something went wrong. Please try again.");
        //                 setLoadingSecrets(false);
        //             });
        //     }
        // }
    }

    function toggleAlert(type, message, description, hide = true, time = 5) {
        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        if (hide) {
            // opacity=0 after 10sec
            setTimeout(() => {
                set_alertOptions(alertOptions => ({
                    status: false,
                    type: type,
                    message: message,
                    description: description,
                }));
            }, time * 1000);
        }
    }

    const filterOption = (input, option) => {
        if (option.key) {
            return (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());
        }
    }


    return (
        <>
            {/* <Alert
                message={alertOptions.message}
                description={alertOptions.description}
                type={alertOptions.type}
                showIcon
                style={alertOptions.status ? marginsBot : fadeMarginBot}
            /> */}

            <CustomModal
                visible={loadingSecrets}
                //onCancel={hideModal}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
                style={{ border: "none", boxShadow: "none" }}
            >
                <div style={{ textAlign: 'center', background: "transparent", border: "none" }}>
                    <Spin size="large" />
                </div>
            </CustomModal>

            <Form
                form={form}
                initialValues={{ ...importData }}
                preserve={false}
                name="dynamic_rule"
                style={{
                    width: "100%",
                    height: "fit-content"
                }}
            >
                <ProdContentHold className='addEnvVar' style={{}}>
                    <Box
                        title="Select to import*"
                        subtitle=""
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{ paddingInline: "49px", marginTop: "105px" }}
                    >
                        {console.log("Import options: ", importOptions)}
                        <Select
                            value={importData.importOption}
                            onChange={handleSelectChange}
                            className="custom-ant-selector"
                            placeholder="Select"
                        //filterOption={filterOption}
                        //notFoundContent={branchLoad ? <Spin size="small" /> : null}
                        >
                            {importOptions}
                        </Select>
                    </Box>
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "rgb(19, 47, 68)" }}>
                        <Box
                            title={
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontSize: "14px"
                                }}>
                                    <span className="header-text">Import Variable</span>
                                    <img src={CloseIcon} style={{ cursor: "pointer", width: "20px", height: "20px", transform: "translateY(15px)" }} alt="close Icon" onClick={handelClick} />
                                </div>
                            }
                            subtitle="Enter details to import new variable"
                            titleStyle={{
                                fontWeight: '500',
                                fontFamily: "Nunito Sans",
                                fontSize: '14px',
                                color: "#ffffff"
                            }}
                            subTitleStyle={{
                                fontWeight: '400',
                                fontFamily: "Nunito Sans",
                                fontSize: '13px',
                                color: "#ffffff"
                            }}
                            style={{
                                // paddingLeft: "20px",
                                position: "absolute",
                                zIndex: "1",
                                width: "100%",
                                top: "0px",
                                height: "83px",
                                backgroundColor: "rgb(19, 47, 68)"
                            }}
                        />
                    </div>
                    {/* Content */}
                    {importData.importOption === "Repo" && <>
                        <div style={{ opacity: file ? "0.7" : "1", pointerEvents: file && "none" }}>
                            <Box
                                title={isPublicImportSource ? "Repo Url*" : "Repo*"}
                                subtitle={isPublicImportSource ? "Repo Url Details" : "Repo Details"}
                                titleStyle={titleStyle}
                                subtitleStyle={subTitleStyle}
                                style={{ paddingInline: "49px" }}
                            >
                                <Form.Item
                                    name="repo"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please provide repo(you can add repo from Workflow Builder tab -> source step).',
                                        },
                                    ]}
                                >
                                    <Input
                                        name="repo"
                                        value={isPublicImportSource ? importData.repo_url : importData.repo}
                                        placeholder={isPublicImportSource ? "Repo url" : "Repo name"}
                                        disabled={true}
                                        style={{
                                            width: "100%",
                                            height: "44px",
                                            border: `1px solid ${(isPublicImportSource ? importData.repo_url : importData.repo) ? `#D0D5DD` : `#f64744`}`,
                                            borderRadius: "8px",
                                            cursor: "not-allowed",
                                            color: "rgba(0, 0, 0, 0.25)",
                                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                                        }}
                                    />
                                </Form.Item>
                                {/* {error.status && error.type && error.type === "branch" && <p className="isoHelperText" style={{ marginTop: "5px", justifyContent: "start" }}>
                                    <span>{error.msg}</span>
                                </p>} */}
                            </Box>

                            {type === "terraform" && <Box
                                title="Execution Path*"
                                titleStyle={titleStyle}
                                style={{ paddingInline: "49px" }}
                            >
                                <Form.Item
                                    name="execution_path"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please provide execution path.',
                                        },
                                    ]}
                                >
                                    <Input
                                        name="execution_path"
                                        defaultValue={importData.execution_path ? "./" + importData.execution_path : ""}
                                        placeholder="Execution Path"
                                        disabled={true}
                                        style={{
                                            width: "100%",
                                            height: "44px",
                                            // border: `1px solid ${error.status && error.type && error.type === "file" ? `#f64744` : `#D0D5DD`}`,
                                            borderRadius: "8px",
                                            cursor: "not-allowed",
                                            color: "rgba(0, 0, 0, 0.25)",
                                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                                        }}
                                    />
                                </Form.Item>
                            </Box>}

                            <Box
                                title="Branch*"
                                subtitle="Branch details"
                                titleStyle={titleStyle}
                                subtitleStyle={subTitleStyle}
                                style={{ paddingInline: "49px" }}
                            >
                                <Form.Item
                                    name="branch"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please provide branch name.',
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                        filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                        onSearch={(value) => {
                                            console.log("Enters search", value);
                                            setSearchValue(value);
                                        }}
                                        value={importData.branch}
                                        onChange={handleSelectChange}
                                        className="custom-ant-selector"
                                        placeholder="Select"
                                        style={{ height: "44px" }}
                                        //filterOption={filterOption}
                                        notFoundContent={importData.repo ? (branchLoad ? <Spin size="small" /> : null) : "no data found"}
                                    >
                                        {repoList}
                                    </Select>
                                </Form.Item>
                            </Box>

                            {importData.branch && type === "terraform" && <Box
                                title={<Tooltip title={"File needs to be on the root directory."} placement="bottomLeft">
                                    <div style={{ display: "flex" }}><p style={{ marginRight: "10px" }}>File name*</p> <InfoCircleFilled style={{ color: "#8896A1" }} /></div>
                                </Tooltip>}
                                titleStyle={titleStyle}
                                style={{ paddingInline: "49px" }}
                            >
                                <Form.Item
                                    name="file"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please provide file name.',
                                        },
                                        {
                                            validator: (_, value) => {
                                                const name = String(value || "").trim().toLowerCase();
                                                if (name.endsWith(".tfvars") || name.endsWith(".tf")) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Please provide correct file name with extension(.tf or .tfvars)'));
                                            }
                                        },
                                    ]}
                                >
                                    <Input
                                        name="file"
                                        value={importData.file}
                                        placeholder="file name"
                                        onChange={(e) => { setImportData((prev) => ({ ...prev, [e.target.name]: e.target.value })) }}
                                        style={{
                                            width: "100%",
                                            height: "44px",
                                            border: `1px solid ${error.status && error.type && error.type === "branch" ? `#f64744` : `#D0D5DD`}`,
                                            borderRadius: "8px",
                                            // cursor: "not-allowed",
                                            // color: "rgba(0, 0, 0, 0.25)",
                                            // backgroundColor: "rgba(0, 0, 0, 0.04)",
                                        }}
                                    />
                                </Form.Item>
                            </Box>}

                            {importData.branch && type !== "terraform" && <Box
                                title={<Tooltip title={"File needs to be on the root directory."} placement="bottomLeft">
                                    <div style={{ display: "flex" }}><p style={{ marginRight: "10px" }}>File*</p> <InfoCircleFilled style={{ color: "#8896A1" }} /></div>
                                </Tooltip>}
                                titleStyle={titleStyle}
                                style={{ paddingInline: "49px" }}
                            >
                                <Select
                                    value={importData.file}
                                    onChange={handleSelectChange}
                                    placeholder="Select"
                                    className="custom-ant-selector"
                                >
                                    {fetching ?
                                        <Option>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                <Spin size="small" />
                                            </div>
                                        </Option>
                                        :
                                        filesList
                                    }
                                </Select>
                            </Box>}
                        </div>
                    </>}

                    {["Upload .tf/.tfvars file", "Upload .env file"].includes(importData.importOption) && <Box
                        title={`Upload ${type === "terraform" ? `.tf/.tfvars` : `.env`} file here*`}
                        subtitle="File Details"
                        // subTitle="Only .tf, .env files are allowed. Please check your file type properly"
                        subtitleStyle={subTitleStyle}
                        titleStyle={titleStyle}
                        style={{ paddingInline: "49px" }}
                    >
                        <div style={{ padding: "10px 0" }}>
                            <UploadFiles types={type === "terraform" ? [".tf", ".tfvars"] : [".env", ".ENV"]} maxSize={2 * 1024 * 1024} files={file ? [file] : []} setFiles={setFile} handleReadFile={handleReadFile} />
                        </div>
                    </Box>}

                    {console.log("Errors: ", error)}

                    {error.status && !error.type && <p className="isoHelperText" style={{ marginTop: "0" }}>
                        <span>{error.msg}</span>
                    </p>}

                    <div style={{ marginBottom: "100px" }}></div>


                    {/* Footer */}
                    <div style={footerStyle}>
                        {!update ?
                            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button className="customButton" style={{ ...buttonCss, marginRight: "30px" }} onClick={() => {
                                    setImportData({
                                        ...importData,
                                        branch: "",
                                        file: "",
                                        uploadContent: false,
                                    });
                                    handelClick();
                                    console.log("Clicked Cancel");
                                }}>
                                    Cancel
                                </Button>
                                <Button className="customButtonActive" style={{ ...buttonCss, background: "#132F44", borderRadius: "8px", color: "#FFFFFF" }} onClick={(e) => handelCreate(e, true)}>
                                    Proceed
                                </Button>
                            </div>
                            :
                            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button className="customButton" style={{ ...buttonCss, marginRight: "30px" }} onClick={() => { }}>
                                    Cancel
                                </Button>
                                <Button className="customButtonActive" style={{ ...buttonCss, background: "#132F44", borderRadius: "8px", color: "#FFFFFF" }} onClick={() => { }}>
                                    Update
                                </Button>
                            </div>
                        }
                    </div>

                </ProdContentHold>
            </Form>
        </>
    );
};